<a id="{{testId}}">
  <span class="nav-icon" *ngIf="icon">
    <i class="fa fa-light {{ icon }}"></i>
  </span>
  <span class="nav-text">
    {{ name }}
    <span *ngIf="isNew" class="isNew label rounded up">
      <i class="fa fa-solid fa-stars text-accent"></i>
    </span>
    <span *ngIf="realTimeValue > 0" class="realTimeValue label rounded up text-white">
      {{realTimeValue}}
    </span>
  </span>
</a>
